import axios from "./http"; // 导入http中创建的axios实例
import checkService from "@/shared/services/check";
// import qs from 'qs';

const clientId = process.env.VUE_APP_AUTHENTICATION_CENTER_CLIENT_ID;
const clientSecret = process.env.VUE_APP_AUTHENTICATION_CENTER_CLIENT_SECRET;
const scopeInfo = process.env.VUE_APP_AUTHENTICATION_CENTER_SCOPE;
const dynamicUrl = process.env.VUE_APP_DYNAMICFORM_API_PATH;
const EHRBaseUrl = process.env.VUE_APP_EHR_API_PATH;

const api = {
  // 登录
  login(entity: any) {
    const body = new URLSearchParams();
    body.set("client_id", clientId);
    body.set("client_secret", clientSecret);
    body.set("scope", scopeInfo);
    body.set("grant_type", entity.grantType);
    body.set("username", entity.username);
    if (checkService.isNotNull(entity.password)) {
      body.set("password", entity.password); // 密码登录
    }
    if (checkService.isNotNull(entity.accountId)) {
      body.set("account_id", entity.accountId); // 企业微信登录
    }
    return axios.AuthenticationCenterPost("/connect/token", body);
  },
  // 获取accesstoken
  getAccesstoken(entity: any, success: any, failure: any) {
    return axios.handleGetToken(
      `/wechat-token/accesstoken`,
      entity,
      success,
      failure
    );
  },
  // 获取userinfo
  getUserInfo(entity: any, success: any, failure: any) {
    return axios.handleGetToken(
      `/wechat-token/userinfo`,
      entity,
      success,
      failure
    );
  },
  // 验证是否绑定
  getIsbind(entity: any, success: any, failure: any) {
    return axios.handleGetToken(
      `/wechat-token/isbind-by-code`,
      entity,
      success,
      failure
    );
  },
  // 获取authtoken
  getAuthtoken(entity: any, success: any, failure: any) {
    return axios.handleGetToken(
      `/wechat-token/authtoken-by-code`,
      entity,
      success,
      failure
    );
  },
  // 获取offerInfo
  getOfferInfoById(id: any) {
    return axios.httpGet(`OfferManagement/noauth/salary/${id}`, null);
  },
  // offer确认表单json
  getConfirmJsonByOfferId(id: string) {
    return axios.httpGet(
      `OfferManagement/noauth/offer/${id}/confirmjson`,
      null
    );
  },
  // offer确认
  confirmOffer(entity: any) {
    return axios.httpPost("OfferManagement/noauth/offerconfirm", entity);
  },

  /**
   * 1.2.2
   */

  // 获取考试测评数据
  getExamsByOpenId(entity: any) {
    return axios.httpGet("HRCenterCandidate/Recruit/Exams", entity);
  },

  // 获取面试测评问卷
  getEvaluationsByOpenId(entity: any) {
    return axios.httpGet("HRCenterCandidate/Recruit/Evaluations", entity);
  },

  // 获取招聘用户面试通知
  getRecruitInterviews(entity: any) {
    return axios.httpGet("HRCenterCandidate/Recruit/Interviews", entity);
  },

  // 候选人操作是否参加面试
  operateInterview(id: any, command: any) {
    return axios.httpPut(
      `HRCenterCandidate/Recruit/Interview/${id}/OperateState`,
      command
    );
  },

  // 判断是否绑定过手机号
  isBindPhone(entity: any) {
    return axios.httpGet("HRCenterCandidate/IsBindPhone", entity);
  },

  // 发送手机验证码
  sendVerifyCode(entity: any) {
    return axios.httpGet("HRCenterCandidate/SendVerifyCode", entity);
  },

  // 绑定手机号
  bindPhone(entity: any) {
    return axios.httpPost("HRCenterCandidate/BindPhone", entity);
  },

  /**
   * 【我的】页面
   */
  // 查询人才库主简历
  queryTalentpoolMainResume(entity: any) {
    return axios.httpGet("HRCenterCandidate/Talentpool/MainResume", entity);
  },

  // 查询招聘主简历
  queryRecruitMainResume(entity: any) {
    return axios.httpGet("HRCenterCandidate/Recruit/MainResume", entity);
  },

  // 查询考试测评的数量
  queryRecruitExams(entity: any) {
    return axios.httpGet("HRCenterCandidate/Recruit/Exams", entity);
  },

  // 查询面试通知的数量
  queryRecruitInterviews(entity: any) {
    return axios.httpGet("HRCenterCandidate/Recruit/Interviews", entity);
  },

  // 查询字典值
  getDictionaries(ids: string[]) {
    return axios.httpGet(
      "HRCenterCandidate/noauth/only-data-dictionaries-values",
      { dictionaryTypeIds: ids }
    );
  },

  // 获取全部省市区
  getProvinceAndCity() {
    return axios.httpGet("HRCenterCandidate/noauth/districts", {});
  },

  // 获取省份信息
  getProvinceInfo() {
    return axios.httpGet('HRCenterCandidate/noauth/districts/top', {});
  },

  // 通过省份获取城市信息
  getCityInfoById(id: string) {
    return axios.httpGet(`HRCenterCandidate/noauth/districts/${id}/children`, {});
  },

  // 添加招聘简历
  addRecruitResume(entity: any) {
    return axios.httpPost("HRCenterCandidate/Recrit/Resumes", entity);
  },

  // 添加人才库简历
  addTalentPoolResume(entity: any) {
    return axios.httpPost("HRCenterCandidate/TalentPool/Resumes", entity);
  },

  // 获取人才库全部简历
  getTalentPoolAllResume(entity: any) {
    return axios.httpGet("HRCenterCandidate/TalentPool/Resumes", entity);
  },

  // 获取招聘全部简历
  getRecruitAllResume(entity: any) {
    return axios.httpGet("HRCenterCandidate/Recruit/MainResumes", entity);
  },

  // 获取招聘简历
  getRecruitResume(entity: any) {
    return axios.httpGet("HRCenterCandidate/Recruit/Resume", entity);
  },
  // 获取招聘简历
  getTalentPoolResume(entity: any) {
    return axios.httpGet("HRCenterCandidate/Talentpool/Resume", entity);
  },
  // 查询招聘用户Offer确认通知
  queryRecruitOfferConfirms(entity: any) {
    return axios.httpGet("HRCenterCandidate/Recruit/OfferConfirms", entity);
  },

  // 编辑招聘简历
  editRecruitResume(entity: any) {
    return axios.httpPut("HRCenterCandidate/Recruit/Resumes", entity);
  },

  // 编辑人才库简历
  editTalentPoolResume(entity: any) {
    return axios.httpPut("HRCenterCandidate/TalentPool/Resumes", entity);
  },

  // 获取职位列表
  getPositions() {
    return axios.httpGet(`/postionInfo`, {});
  },

  // 上传档案附件
  addfileInfo(param: any) {
    return axios.httpPost(`uploadfile/wechat`, param);
  },

  // 查询职位列表
  getHRCenterPositionsInfo(param: any) {
    return axios.httpPost(`HRCenterCandidate/positions`, param);
  },

  /** @description EHR接口
   */
  // 查询EHR岗位列表
  getPositionsByEHR(param: any) {
    return axios.httpGet(`${EHRBaseUrl}WeChatInterface/RecruitmentSchoolWeChat/GetPostList`, param);
  },

  // 获取Unionid
  getRecruitUnionIdByEHR(param: any) {
    return axios.httpGet(`${EHRBaseUrl}Recruitment/RecruitmentSchool/GetUnionidAndOpenid`, param);
  },

  // 获取简历状态
  getResumeState(param: any) {
    return axios.httpGet(`${EHRBaseUrl}WeChatInterface/RecruitmentSchoolWeChat/GetJudgeUseInsertOrUpdate`, param);
  },

  // 校招-解析简历
  analyzeSchoolResume(param: any) {
    return axios.httpPost(`campus/recruitmentapplication/ResumeAnalyze`, param);
  },

  // 校招-提交简历
  submitSchoolResume(param: any) {
    return axios.httpPost(`campus/recruitmentapplication/ResumeSubmit`, param);
  },

  // 校招-获取简历
  getSchoolResume(param: any) {
    return axios.httpPost(`campus/recruitmentapplication/ResumeDetail`, param);
  },

};

export default api;
